$contextualNavigationMobile = $("#app-contextual-navigation-mobile");
$contextualNavigationDesktop = $("#app-contextual-navigation-desktop");
$contextualNavigationDesktopInner = $("#app-contextual-navigation-desktop-inner");
$contextualNavigationDesktopMenus = $("#app-contextual-navigation-desktop-menus");
$contextualNavigationDesktopLocker = $("#app-contextual-navigation-desktop-locker");
$contextualNavigationDesktopFa = $("#app-contextual-navigation-desktop-fa");

var $contextualNavigationTrigger = $("#contextual-navigation-trigger");
var $app = $("#app");
var $hideTimeout = false;
var $lockerDisabled = false;

$contextualNavigationDesktop.removeClass('duration-300').addClass('duration-0')
$contextualNavigationDesktopInner.removeClass('duration-300').addClass('duration-0')
try {
    var $navBoxWidth = Math.round($contextualNavigationDesktopMenus.removeClass('w-full').children().removeClass('w-[18rem]')[0].getBoundingClientRect().width) + 20
} catch (e) {
    var $navBoxWidth = 0;
}
$contextualNavigationDesktop.removeClass('w-[1.25rem]').css('width', '20px')
$contextualNavigationDesktopMenus.addClass('w-full').children().removeClass('w-[18rem]').css('width', $navBoxWidth + 'px')
$contextualNavigationDesktopInner.removeClass('w-[18rem]').css('width', $navBoxWidth + 'px')


window.hideContextualNavigation = function () {
    $contextualNavigationDesktop.css('width', '20px')
    $contextualNavigationDesktopInner.css('width', '20px')
    $contextualNavigationDesktopMenus.removeClass('overflow-y-scroll')
    $contextualNavigationDesktopMenus.addClass('overflow-y-hidden')
    $contextualNavigationDesktopFa.removeClass('fa-arrow-left')
    $contextualNavigationDesktopFa.addClass('fa-arrow-right')
    $contextualNavigationDesktopLocker.css('opacity', '1')

//    $contextualNavigationDesktop.addClass('hidden');
    setTimeout(() => {
        $app.addClass('nav-hidden');
        $contextualNavigationDesktopLocker.css('opacity', '1')
    }, 200)
    $('.contextual-navigation-show-button').show();
    $('.contextual-navigation-hide-button').hide();
    if (window.appUrls) {
        axios.put(appUrls.users.menu_prefs, {expanded: false});
    }
};

window.showContextualNavigation = function () {
    $contextualNavigationDesktop.css('width', $navBoxWidth + 'px')
    $contextualNavigationDesktopInner.css('width', $navBoxWidth + 'px')
    $contextualNavigationDesktopMenus.removeClass('overflow-y-hidden')
    $contextualNavigationDesktopMenus.addClass('overflow-y-scroll')
    $contextualNavigationDesktopFa.removeClass('fa-arrow-right')
    $contextualNavigationDesktopFa.addClass('fa-arrow-left')

//    $contextualNavigationDesktop.removeClass('hidden');
//    $contextualNavigationDesktop.show();
    $app.removeClass('nav-hidden');
    $('.contextual-navigation-show-button').hide();
    $('.contextual-navigation-hide-button').show();
    if (window.appUrls) {
        axios.put(appUrls.users.menu_prefs, {expanded: true});
    }
};

$contextualNavigationDesktopLocker.on('click', () => {
    if ($app.hasClass('nav-hidden')) {
        showContextualNavigation()
    } else {
        hideContextualNavigation()
    }
})

$contextualNavigationDesktopLocker.on('mouseover', () => {
    if ($app.hasClass('nav-hidden')) {
        $lockerDisabled = true;
    }
})
$contextualNavigationDesktopLocker.on('mouseout', () => {
    $lockerDisabled = false;
})

$contextualNavigationDesktopInner.on('mouseover', () => {
    $contextualNavigationDesktopLocker.css('opacity', '1')
    if ($lockerDisabled) return;
    if ($hideTimeout) {
        clearTimeout($hideTimeout)
    }
    $hideTimeout = setTimeout(() => {
        if ($app.hasClass('nav-hidden')) {
            $contextualNavigationDesktopInner.css('width', $navBoxWidth + 'px')
            $contextualNavigationDesktopMenus.removeClass('overflow-y-hidden')
            $contextualNavigationDesktopMenus.addClass('overflow-y-scroll')
        }
    }, 50)
})
$contextualNavigationDesktopInner.on('mouseleave', () => {
    if ($lockerDisabled) return;
    if ($hideTimeout) {
        clearTimeout($hideTimeout)
    }
    if (!$app.hasClass('nav-hidden')) {
        $contextualNavigationDesktopLocker.css('opacity', '0')
    }
    $hideTimeout = setTimeout(() => {
        if ($app.hasClass('nav-hidden')) {
            $contextualNavigationDesktopInner.css('width', '20px')
            $contextualNavigationDesktopMenus.removeClass('overflow-y-scroll')
            $contextualNavigationDesktopMenus.addClass('overflow-y-hidden')
        }
    }, 250)
})


// Do some contextual-navigation specific stuff such as removing it if there is no contextual nav
if ($contextualNavigationMobile.children().length === 0) {
    // There is no contextual navigation present so we should remove it from the system
    $contextualNavigationMobile.remove();
    $contextualNavigationDesktop.remove();
    $contextualNavigationTrigger.remove();
    $app.addClass('no-navigation');
} else {
    window.addEventListener('keydown', (e) => {
        if (e.ctrlKey || e.metaKey) {
            return;
        }
        if (['input', 'INPUT', 'textarea', 'TEXTAREA'].includes(e.target.tagName)) {
            return;
        }
        if (['input', 'INPUT', 'textarea', 'TEXTAREA'].includes(document.activeElement.tagName)) {
            return;
        }
        if (e.key === '[') {
            if (!$app.hasClass('nav-hidden')) {
                hideContextualNavigation()
            } else {
                showContextualNavigation()
            }
            e.preventDefault();
            e.stopPropagation();
        }
    })
    // Let's loop through each navigation item and determine if, based on the contents, it should be a dropdown.
    // If it is, then we'll attach some more click events and also change the presentation slightly with classes.
    $contextualNavigationDesktop.find('>ul>li').each(function (elem) {
        if ($(this).find('ul').length) {
            $(this).addClass('is-dropdown');
            var $containerElement = $(this);
            $(this).find('a').first().append('<i class="fa fa-angle-down" aria-hidden="true"></i>');
            $containerElement.addClass('dropdown-open');
            $(this).find('a').first().on('click', function (e) {
                e.preventDefault();
                $containerElement.toggleClass('dropdown-open');
                showContextualNavigation();
            });
        }
    });

    // Wrap the stray text nodes with span elements to show and hide on collapse
    $contextualNavigationDesktop.find('>ul>li>a')
        .contents()
        .filter(function () {
            return this.nodeType === 3 && $.trim(this.nodeValue) !== '';
        })
        .wrap('<span/>');

    // Add tooltips to the existing a links based on the content already there
    // Aim is to keep the blade templates as simple as possible.
    $contextualNavigationDesktop.find('>ul>li>a>span').each(function () {
        var foundSpanContents = $(this).contents().filter(function () {
            return this.nodeType === 3 && $.trim(this.nodeValue) !== '';
        });
        $(this).parent('a').attr('title', $.trim(foundSpanContents[0].nodeValue));
    });

//    $contextualNavigationDesktop.append('<div class="contextual-navigation-expander"></div>');
//    $('.contextual-navigation-expander').first().append('<a class="contextual-navigation-hide-button" href="#"><i class="fa fa-caret-left" aria-hidden="true"></i> Hide</a>');
//    $('.contextual-navigation-expander').first().append('<a class="contextual-navigation-show-button" href="#"><i class="fa fa-caret-right" aria-hidden="true"></i></a>');

    $('.contextual-navigation-show-button').hide();

    $('.contextual-navigation-hide-button').on('click', function (e) {
        e.preventDefault();
        hideContextualNavigation();
    });

    $('.contextual-navigation-show-button').on('click', function (e) {
        e.preventDefault();
        showContextualNavigation();
    });

    // Make the contextual navigation as per user's preference
    if (window.addData && (appData.user.menu_type === 'minimal')) {
        hideContextualNavigation();
    } else {
        showContextualNavigation();
        $contextualNavigationDesktopLocker.css('opacity', '0')
    }
    setTimeout(() => {
        $contextualNavigationDesktopLocker.removeClass('duration-0').addClass('duration-500')
        $contextualNavigationDesktop.removeClass('duration-0').addClass('duration-300')
        $contextualNavigationDesktopInner.removeClass('duration-0').addClass('duration-300')
    }, 100)

    $('#contextual-menu-nested-back-button').on('click', function (e) {
        e.preventDefault();
        backOutOfNestedMenu();
    });

    // The mobile contextual navigation heirachical navigation functionality
    $contextualNavigationMobile.find('>ul>li').last().css('padding-bottom', '4em');
    $contextualNavigationMobile.find('>ul>li').each(function (elem) {
        if ($(this).find('ul').length) {
            var $containerElement = $(this);
            $(this).find('ul').css('display', 'none');

            $(this).find('a').first().on('click', function (e) {
                e.preventDefault();
                $('#contextual-menu-nested-back-button').addClass('visible');
                $('#mobile-menu-button').addClass('contextual-back-button-present');
                $containerElement.toggleClass('dropdown-open');
                $contextualNavigationMobile.find('>ul>li').css('display', 'none');
                $containerElement.css('display', 'block');
                $containerElement.find('a').first().css('display', 'none');
                $containerElement.find('ul').css('display', 'block');
            });
        }
    });

    // By this point, we do have a contextual navigation to care about.
    // Let's add some click events to toggle the appropriate classes for visual display
    $app.removeClass('no-navigation');

    $contextualNavigationTrigger.on('click', function (e) {
        e.preventDefault();
        backOutOfNestedMenu();
        $contextualNavigationMobile.toggleClass('open');
        $app.toggleClass('contextual-navigation-menu-open');
        $contextualNavigationTrigger.toggleClass('menu-open');

        if ($contextualNavigationMobile.hasClass('open')) {
            $('#mobile-menu-button').hide();
        } else {
            $('#mobile-menu-button').show();
        }

    });
}
